// @flow
import { LogsActionTypes } from './constants';

type LogsAction = { type: string, payload: {} | string };

// common success
export const logsApiResponseSuccess = (actionType: string, data: any): LogsAction => ({
    type: LogsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const logsApiResponseError = (actionType: string, error: string): LogsAction => ({
    type: LogsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getLog = (id: string): LogsAction => ({
    type: LogsActionTypes.GET_LOG,
    payload: { id },
});

export const addLog = (log:any):LogsAction=>({
    type:LogsActionTypes.ADD_LOG,
    payload:log
})
export const updateLog = (log:any):LogsAction=>({
    type:LogsActionTypes.UPDATE_LOG,
    payload:log
})
export const deleteLog = (id:string):LogsAction=>({
    type:LogsActionTypes.DELETE_LOG,
    payload:{id}
})

export const listLogs = (params:any): LogsAction => ({
    type: LogsActionTypes.LIST_LOGS,
    payload: params,
});


export const resetLogs = (): LogsAction => ({
    type: LogsActionTypes.RESET,
    payload: {},
});

export const fetchDistinctUsers = (): LogsAction => ({
    type: LogsActionTypes.DISTINCT_USERS,
    payload: {},
});

